import * as React from 'react';
import { SystemEventLevel } from 'bernie-logger';
import { useHistory, useLocation } from 'react-router-dom';

import { FlightsSortAndFilters } from '@shared-ui/retail-search-tools-flights';

import { useSortAndFilterInput, useStores } from 'utility/hooks';
import { triggerSortSearchCall } from 'experiments/PWA_USF_FSR/usf-utils';
import { logEvent } from 'experiments/Air_Smart_Shopping_44809/utils';
import { SortAndFiltersViewType } from 'types/search/sort-filter';

export const UniversalSortTabs = () => {
  const { context, searchCriteriaStore } = useStores();
  const location = useLocation();
  const history = useHistory();
  const sortAndFilterInput = useSortAndFilterInput();

  const handleOnFieldChange = React.useCallback(
    field => triggerSortSearchCall(field, searchCriteriaStore, context, history, location),
    [searchCriteriaStore, context, history, location]
  );

  const onEmptyResults = React.useCallback(() => {
    logEvent(SystemEventLevel.ERROR, 'SMART_SHOPPING_SORT_TABS_ERROR', 'Smart shopping sort tabs not rendered');
  }, []);

  if (!searchCriteriaStore?.searchCriteria?.journeyCriteria[0].departureDate.day) {
    return null;
  }

  return (
    <FlightsSortAndFilters
      onFieldChange={handleOnFieldChange}
      view={SortAndFiltersViewType.SORT_TABS}
      inputs={sortAndFilterInput}
      onEmptyResults={onEmptyResults}
    />
  );
};
